import { render } from "./Replenishments.vue?vue&type=template&id=4821edac"
import script from "./Replenishments.vue?vue&type=script&lang=js"
export * from "./Replenishments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__